<template>
  <div
    v-if="uiStore.isLoading"
    class="fixed inset-0 bg-gray-800 bg-opacity-75 flex flex-col items-center justify-center z-50"
  >
    <svg
      class="animate-spin h-10 w-10 text-white mb-4"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
    <h2 class="text-xl font-semibold text-white">{{ t(loading) }}</h2>
  </div>
  <RouterView />
</template>
<script setup lang="ts">
import { useUIStore } from './stores/uiStore'
import { watchEffect } from 'vue'
import { useI18n } from 'vue-i18n'
import { useUserStore } from './stores/user'

const { t } = useI18n()

const loading = 'basics.loading'

const user = useUserStore()
const { locale } = useI18n()
const uiStore = useUIStore()

watchEffect(() => {
  const userLanguage = user.profile.languageCode

  if (!user.profile.isLoading && userLanguage && locale.value !== userLanguage) {
    console.log(`Setting app locale to user preference: ${userLanguage}`)
    locale.value = userLanguage
  }
})
</script>
<style lang="scss">
#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}
</style>
